import { FC } from 'react';
import * as CS from 'view/pages/auth/commonStyled';

interface CheckOrVerifyEmailProps {
  title: string;
  currentEmail: string;
  subtitle: string;
  description: string;
}

const CheckOrVerifyEmail: FC<CheckOrVerifyEmailProps> = ({
  title,
  currentEmail,
  subtitle,
  description,
}) => {
  return (
    <>
      <CS.CheckOrVerifyEmailText component="p">
        {title} <br /> <span>{currentEmail}</span>
      </CS.CheckOrVerifyEmailText>
      <CS.CheckOrVerifyEmailText component="p">{subtitle}</CS.CheckOrVerifyEmailText>
      <CS.CheckOrVerifyEmailText component="p">{description}</CS.CheckOrVerifyEmailText>
    </>
  );
};

export default CheckOrVerifyEmail;
